import {
    COMMISSIONS_GET_POLICY_BY_ID_BEGIN,
    COMMISSIONS_GET_POLICY_BY_ID_SUCCESS,
    COMMISSIONS_GET_POLICY_BY_ID_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GET_POLICY_BY_ID_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies, 
            getPolicyByIdError:false,  
            getPolicyByIdSuccess:false,
          },
        }
      case COMMISSIONS_GET_POLICY_BY_ID_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies, 
            basicInformation: {
              ...state.policies.basicInformation,
              carLotId :action.data.car_lot_id,
              carLotName:action.data.car_lot_name,
              saleType:action.data.sale_type === "CONVENCIONAL" ? "Convencional" : "Usados",
              branchId:action.data.branch_office_id,
              commissionName:action.data.name,
            },
            getPolicyByIdError:false,
            getPolicyByIdSuccess:true,
          },
        }
      case COMMISSIONS_GET_POLICY_BY_ID_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies, 
            basicInformation: {
              carLotId :"",
              carLotName:"",
              saleType:"",
              branchId:"",
              commissionName:"",
            },
            getPolicyByIdError:action.data.error,
            getPolicyByIdSuccess:false,
          },
        }
      default:
        return state
    }
  }